import React, { Component } from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import Logo from './components/Logo/Logo';
import FrontPage from './container/FrontPage/FrontPage';
import classes from './App.module.css';
import LearningVideo from './components/LearningTile/LearningVideo/LearningVideo';

class App extends Component {
  state = {
    currentDate: ''
  }
  componentDidMount() {
    let date = new Date().getFullYear();
    this.setState({ currentDate: date });

    /* iPhone Nutzermeldung auf mobile Safari */
    var iPhone = /iPhone/i.test(navigator.userAgent)
    let isSafari = iPhone && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent));

    if(isSafari){
      alert("Bitte beachten Sie, dass auf Ihrem Gerät der Vollbildmodus, während des Abspielens der Videos, durch die Nutzung des Safari Browsers negativ beeinträchtigt wird. Für eine fehlerfreie Nutzung benutzen Sie bitte die Google Chrome Applikation");
    }

  }
  render() {
    return (
      <div className={classes.App}>
        <BrowserRouter basename={'schulungsvideos/'}>
          <Logo />
          <div className={classes.Container}>
            {/* default cases to use Routing on React Projects */}
            <Switch> {/*tells react router to load only one route at the same time */}
              <Route path="/modul-ambulante-medizin" component={LearningVideo} isModul="ambulante-medizin" exact />
              <Route path="/modul-normalstation" component={LearningVideo} isModul="normalstation" exact />
              <Route path="/modul-intensivstation" component={LearningVideo} isModul="normalstation" exact /> 
              <Route path="/" component={FrontPage} exact /> }
            </Switch>
          </div>
          <div className={classes.Footer}>
            <span>(C) {this.state.currentDate} . alle Rechte Vorbehalten .</span>
            <div className={classes.Extern}>
              <a href="https://www.aktion-sauberehaende.de/impressum" target="_blank" rel="noreferrer">Impressum</a>
              <a href="https://www.aktion-sauberehaende.de/datenschutz" target="_blank" rel="noreferrer">Datenschutzerklärung</a>
              <a href="https://www.aktion-sauberehaende.de/ueber-uns-ash" target="_blank" rel="noreferrer">Über Uns</a>
            </div>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;